import * as React from 'react'
import { AppRoutes } from '@repo/web-utils/app-routes'
import { AmplitudeEvents, sendAmplitudeEvent } from '@repo/analytics/amplitude/utils'

import { studioBaseUrl } from '../../utils/urls'
import { GradientColoredSparkIcon } from '../icons/gradient-colored-spark-icon'
import { useIsLoggedIn } from '../../hooks/use-auth'
import * as MenuItem from '../menu-item'
import { useTranslations } from '../../contexts/header-config-context'
import {
  PAYMENT_ENTRY_POINTS,
  savePaymentModalEntryPoint,
} from 'payments/payments-dialog/analytics'
import { useStartFreeTrial } from 'payments/start-free-trial-button/hooks/use-start-free-trial'

export const HeaderCTA = () => {
  const isLoggedIn = useIsLoggedIn()

  const showFreeTrialCTA = !isLoggedIn
  const t = useTranslations()
  const { startFreeTrial } = useStartFreeTrial()

  if (showFreeTrialCTA) {
    return <span className="w-[80px]" />
  }

  return (
    <MenuItem.Link
      href={showFreeTrialCTA ? AppRoutes.B_FREE_TRIAL : studioBaseUrl}
      target={showFreeTrialCTA ? '_self' : '_blank'}
      onClick={async (e: React.MouseEvent<HTMLAnchorElement>) => {
        sendAmplitudeEvent(AmplitudeEvents.MAIN_MENU_STUDIO_BUTTON_CLICKED)
        if (isLoggedIn && showFreeTrialCTA) {
          e.preventDefault()
          savePaymentModalEntryPoint(PAYMENT_ENTRY_POINTS.MAIN_MENU_STUDIO_BUTTON)
          await startFreeTrial()
        }
      }}
      className="ml-4 h-full flex-col justify-between gap-1 px-2 py-1.5"
    >
      <GradientColoredSparkIcon />
      <span className="min-w-14 text-center drop-shadow">
        {showFreeTrialCTA ? t('top_nav.free_trial') : t('top_nav.create')}
      </span>
    </MenuItem.Link>
  )
}
